// This provides an interface to access all the controllers using this mixin.
//  Note that this mixin only works for stimulus controller located in the same page.

// Steps to use this mixin on a stimulus controller:
//  1. Import this mixin.
//  2. Call useBusItem(this) on your connect. (Assuming it was imported as useBusItem)
//  3. On the disconnect() callback method, call the method this.removeFromBus()
//  4. Define a busItemId stimulus value.
//      This id it's used when calling the this.getBusItem(id) method

export const useBusItem = (controller, opts = {}) => {
  const options = Object.assign({ addToBus: true }, opts)

  Object.assign(controller, {
    // PUBLIC
    // Adds current stimulus controller bus item to bus
    addToBus() {
      controller._bus()[controller._busItemId()] = controller
    },

    // Removes current stimulus controller bus item from bus
    removeFromBus() {
      delete controller._bus()[controller._busItemId()]
    },

    // Retrieves a bus item with a specific id
    getBusItem(id) {
      return controller._bus()[controller._genBusItemId(id)]
    },

    // PRIVATE
    _genBusItemId(id) {
      return `${id}-bus-item`
    },
    _busItemId() {
      let id = controller.identifier
      if (controller.busItemIdValue && controller.hasBusItemIdValue) { id = controller.busItemIdValue }
      return controller._genBusItemId(id)
    },
    _bus() {
      const busId = 'stimulus-controller-global-bus'
      const bus = document[busId]
      if (bus === null || bus === undefined) {
        document.addEventListener('turbolinks:before-visit', function() {
          delete document[busId]
        }, { once: true })
        document[busId] = {}
      }
      return document[busId]
    }
  })

  if (options.addToBus) controller.addToBus()
}
